module.exports = __webpack_public_path__ + "static/media/achesoothe-2.94e6adcd.png";